import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import {
    Button,
    Checkbox,
    Col,
    Drawer,
    Input,
    InputGroup,
    InputPicker,
    Row
} from 'rsuite';
import { limitCharacterLength, tenthsDecimalInputMask, textNumbersSymbolsInputmask } from '../../../../resources/logic/inputMasks';
import DebouncedButton from '../../../componentsGeneral/Rsuite/Button/DebouncedButton';


const styles = {
    // width: 300,
    marginBottom: 5,
    width: '100%'
};


const mountRef = React.createRef();

const EditItemDrawer = ({ onChangeState, show, placement, confirm, close, state, ...props }) => (

    <Drawer show={state.showEditItemDrawer} onHide={close} placement={placement} style={props.isMobile ? { width: '350px' } : { width: '650px' }}    >
        <Drawer.Header>
            <Drawer.Title>Edit Item: {state.editSku} </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>

            <Container maxWidth={false} style={{ width: '100%' }}>

                <Paper elevation={3} style={{ padding: '15px', marginTop: '15px', width: '100%' }}>
                    {/* 
                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>SKU:</InputGroup.Addon>
                            <Input value={state.editSku} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'editSku')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 50)} />
                        </InputGroup>
                    </Row> */}

                    {/* <Row >
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Warehouse:</InputGroup.Addon>
                            <InputPicker preventOverflow
                                container={() => mountRef.current}
                                placeholder={'Warehouse...'}
                                value={state.editWarehouseID}
                                onChange={(e) => { onChangeState(e, 'editWarehouseID') }}
                                data={state.warehouseArray}
                                style={{ width: '100%' }}
                                block
                                cleanable={true}
                            />
                        </InputGroup>
                    </Row>

                    <Row >
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Customer:</InputGroup.Addon>
                            <InputPicker preventOverflow
                                container={() => mountRef.current}
                                placeholder={'Customer...'}
                                value={state.editCustomerID}
                                onChange={(e) => { onChangeState(e, 'editCustomerID') }}
                                data={state.customerArray}
                                style={{ width: '100%' }}
                                block
                                cleanable={true}
                            />
                        </InputGroup>
                    </Row> */}

                    <Row >
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Customer Ref:</InputGroup.Addon>
                            <InputPicker preventOverflow
                                container={() => mountRef.current}
                                placeholder={'Customer Ref...'}
                                value={state.editCustomerRef}
                                onChange={(e) => { onChangeState(e, 'editCustomerRef') }}
                                data={props.InventoryCustomerRefData}
                                style={{ width: '100%' }}
                                block
                                cleanable={true}
                                creatable
                            />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Project:</InputGroup.Addon>
                            <InputPicker preventOverflow
                                container={() => mountRef.current}
                                placeholder={'Project...'}
                                value={state.editProject}
                                onChange={(e) => { onChangeState(e, 'editProject') }}
                                data={props.InventoryProjectData}
                                style={{ width: '100%' }}
                                block
                                cleanable={true}
                                creatable
                            />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>PGA Flag:</InputGroup.Addon>
                            <Checkbox checked={state.editPGAFlag} onChange={(e, checked) => onChangeState(checked, 'editPGAFlag')} />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Product Name:</InputGroup.Addon>
                            <Input value={state.editProductName} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'editProductName')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 300)} />
                        </InputGroup>
                    </Row>


                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Product Details:</InputGroup.Addon>
                            <Input value={state.editProductDetails} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'editProductDetails')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 300)} />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Product URL:</InputGroup.Addon>
                            <Input value={state.editProductURL} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'editProductURL')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 300)} />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Product Country of Origin:</InputGroup.Addon>
                            <Input value={state.editProductCountryofOrigin} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'editProductCountryofOrigin')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 300)} />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>HTS Code:</InputGroup.Addon>
                            <Input value={state.editHTSCode} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'editHTSCode')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 10)} />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Notes:</InputGroup.Addon>
                            <Input value={state.editNotes} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'editNotes')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 400)} />
                        </InputGroup>
                    </Row>








                    <Row>
                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <InputGroup.Addon>L:</InputGroup.Addon>
                                <Input value={state.editLength}
                                    placeholder={'Length'}
                                    onChange={(e) => { onChangeState(e, 'editLength') }}
                                    onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
                                />
                            </InputGroup>
                        </Col>

                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <InputGroup.Addon>W:</InputGroup.Addon>
                                <Input value={state.editWidth}
                                    placeholder={'Width'}
                                    onChange={(e) => { onChangeState(e, 'editWidth') }}
                                    onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
                                />
                            </InputGroup>
                        </Col>

                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <InputGroup.Addon>H:</InputGroup.Addon>
                                <Input value={state.editHeight}
                                    placeholder={'Height'}
                                    onChange={(e) => { onChangeState(e, 'editHeight') }}
                                    onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
                                />
                            </InputGroup>
                        </Col>

                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <InputPicker preventOverflow
                                    container={() => mountRef.current}
                                    placeholder={'Unit of Measure...'}
                                    value={state.editUomID}
                                    onChange={(e) => { onChangeState(e, 'editUomID') }}
                                    data={props.CommonUnitOfMeasureData}
                                    style={{ width: '100%' }}
                                    block
                                    cleanable={false}
                                />
                            </InputGroup>
                        </Col>

                    </Row>



                    <Row>
                        <Col md={18} sm={18}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <InputGroup.Addon>Weight:</InputGroup.Addon>
                                <Input value={state.editWeight}
                                    placeholder={'Weight'}
                                    onChange={(e) => { onChangeState(e, 'editWeight') }}
                                    onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
                                />
                            </InputGroup>
                        </Col>


                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <InputPicker preventOverflow
                                    container={() => mountRef.current}
                                    placeholder={'Unit of Weight...'}
                                    value={state.editUowID}
                                    onChange={(e) => { onChangeState(e, 'editUowID') }}
                                    data={props.CommonUnitOfWeightData}
                                    style={{ width: '100%' }}
                                    block
                                    cleanable={false}
                                />
                            </InputGroup>
                        </Col>

                    </Row>



                </Paper>



                <Paper elevation={3} style={{ padding: '15px', marginTop: '15px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <DebouncedButton onClick={confirm} buttonText="Save" />

                        <Button variant="contained" color="primary" onClick={(e) => close(e)} style={{ marginLeft: '10px' }}>
                            Cancel
                        </Button>
                    </div>
                </Paper>





                <br />
                <br />


            </Container>


        </Drawer.Body>
        <Drawer.Footer>
            <br />
        </Drawer.Footer>

    </Drawer>

);



EditItemDrawer.defaultProps = {
    show: false
};

export default EditItemDrawer;








// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
// <InputGroup.Addon>Length:</InputGroup.Addon>
// <Input value={state.editLength}
//     onChange={(e) => { onChangeState(e, 'editLength') }}
//     onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
// />
// </InputGroup>


// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
// <InputGroup.Addon>Width:</InputGroup.Addon>
// <Input value={state.editWidth}
//     onChange={(e) => { onChangeState(e, 'editWidth') }}
//     onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
// />
// </InputGroup>

// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
// <InputGroup.Addon>Height:</InputGroup.Addon>
// <Input value={state.editHeight}
//     onChange={(e) => { onChangeState(e, 'editHeight') }}
//     onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
// />
// </InputGroup>

// <Row >
// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
//     <InputGroup.Addon>Unit of Measure:</InputGroup.Addon>
//     <InputPicker preventOverflow
//         container={() => mountRef.current}
//         placeholder={'Unit of Measure...'}
//         value={state.editUomID}
//         onChange={(e) => { onChangeState(e, 'editUomID') }}
//         data={props.InventoryCustomerRefData}
//         style={{ width: '100%' }}
//         block
//         cleanable={false}
//     />
// </InputGroup>
// </Row>

// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
// <InputGroup.Addon>Weight:</InputGroup.Addon>
// <Input value={state.editWeight}
//     onChange={(e) => { onChangeState(e, 'editWeight') }}
//     onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
// />
// </InputGroup>


// <Row >
// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
//     <InputGroup.Addon>Unit of Weight:</InputGroup.Addon>
//     <InputPicker preventOverflow
//         container={() => mountRef.current}
//         placeholder={'Unit of Weight...'}
//         value={state.editUowID}
//         onChange={(e) => { onChangeState(e, 'editUowID') }}
//         data={props.InventoryCustomerRefData}
//         style={{ width: '100%' }}
//         block
//         cleanable={false}
//     />
// </InputGroup>
// </Row>
